<template>
  <div class="mt-4 px-4 container-fluid">
    <div class="breadcrumb text-md px-0 mb-4">
      <p><span class="breadcrumb-item" @click="irInicio">Inicio</span> > Productos</p>
    </div>
  </div>
  
  <div class="px-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card ficha-buscador">
          <div class="titulo"><h5 class="mx-4 mt-5 mb-5">Listado de Servicios</h5></div>
          <div class="table-search">
            <input id="textoBuscador" type="text" class="form-control" placeholder="Búsqueda rápida..." aria-label="Búsqueda rápida" @input="teclearBuscador" />
          </div>
          <div class="filtro-tipster" v-if="miRol == 1">
            <select v-model="filtroTipsterId" class="form-control form-control-sm" @change="cambiarFiltroTipster">
              <option value="">Todos los tipsters</option>
              <option v-for="t in listaTipsters" :key="t.id" :value="t.id">{{ t.nombre }}</option>
            </select>
          </div>
          <!-- Filtros tipo y estado -->
          <div class="filtros-prod">
            <div class="filtros-prod__grupo">
              <button v-for="op in [{val:'',label:'Todos'},{val:'suscripcion',label:'Suscripción'},{val:'unico',label:'Pago único'}]"
                :key="op.val" class="filtro-pill" :class="{'filtro-pill--active': filtroTipo===op.val}"
                @click="filtroTipo=op.val">{{ op.label }}</button>
            </div>
            <div class="filtros-prod__grupo">
              <button v-for="op in [{val:'',label:'Todos'},{val:'activo',label:'Activos'},{val:'inactivo',label:'Inactivos'}]"
                :key="op.val" class="filtro-pill" :class="{'filtro-pill--active': filtroActivo===op.val}"
                @click="filtroActivo=op.val">{{ op.label }}</button>
            </div>
          </div>
          <div class="descarga triple">
            <p @click="descargarCSV"><i class="fa fa-download" aria-hidden="true"></i></p>
            <p @click="abrirAltaProducto"><i class="fa fa-plus" aria-hidden="true"></i></p>
            <p @click="toggleSelectorColumnas" title="Columnas visibles" :class="{ 'activo': selectorColumnasAbierto }"><i class="fas fa-columns" aria-hidden="true"></i></p>
          </div>

          <!-- Selector de columnas -->
          <div v-if="selectorColumnasAbierto" class="selector-columnas-panel" v-click-outside="cerrarSelectorColumnas">
            <div class="selector-columnas-header">
              <span>Columnas visibles</span>
              <button class="selector-reset" @click="resetColumnas" title="Restablecer">Restablecer</button>
            </div>
            <div class="selector-columnas-grid">
              <label v-for="col in columnasConfig" :key="col.key" class="selector-col-item" :class="{ disabled: col.fija }">
                <input type="checkbox" v-model="columnasVisibles[col.key]" :disabled="col.fija" @change="guardarColumnasStorage" />
                <span class="selector-col-dot" :style="{ background: col.color }"></span>
                <span>{{ col.label }}</span>
              </label>
            </div>
          </div>
          <div class="borrados">
            <QToggle v-model="mostrarBorrados" @change="cambiarBorrados" />
            <span class="borrados-label">{{ mostrarBorrados ? 'Con eliminados' : 'Sin eliminados' }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="px-4 container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card ficha-listado mt-4">
          <div class="px-4 pb-0 card-body">
            <div class="table-responsive mb-4">
              <table id="productos-list" class="table table-flush table-listado">
                <thead class="thead-light">
                  <tr>
                    <th @click="sortTable('0')" :class="sortColumn=='0' ? sortDirection : ''">Nombre</th>
                    <th @click="sortTable('1')" :class="[sortColumn=='1' ? sortDirection : '', { 'd-none': !columnasVisibles.enlace }]">Enlace</th>
                    <th @click="sortTable('2')" :class="[sortColumn=='2' ? sortDirection : '', { 'd-none': !columnasVisibles.precio }]">Precio</th>
                    <th :class="{ 'd-none': !columnasVisibles.precio_real }" class="sin-orden">Precio real</th>
                    <th @click="sortTable('3')" :class="[sortColumn=='3' ? sortDirection : '', { 'd-none': !columnasVisibles.tipster }]" v-if="miRol==1">Tipster</th>
                    <th @click="sortTable('4')" :class="sortColumn=='4' ? sortDirection : ''">Activado</th>
                    <th @click="sortTable('5')" data-type="date" data-format="DD/MM/YYYY" :class="[sortColumn=='5' ? sortDirection : '', { 'd-none': !columnasVisibles.creado }]">Creado</th>
                    <th @click="sortTable('6')" :class="[sortColumn=='6' ? sortDirection : '', { 'd-none': !columnasVisibles.eliminado }]" v-if="mostrarBorrados">Eliminado</th>
                    <th data-type="html" data-sortable="false" class="sin-orden">Acciones</th>
                  </tr>
                </thead>
                <tbody class="text-sm">
                  <!-- Ciclo a través de los elementos filtrados y paginados -->
                  <tr v-for="row in filasVisibles" :key="row.id">
                    <td>
                      {{ row.nombre }}
                      <span v-if="row.tipo_venta && row.tipo_venta !== 'venta_unica'" class="prod-badge prod-badge--susc">Suscripción</span>
                      <span v-else-if="row.tipo_venta === 'venta_unica'" class="prod-badge prod-badge--unico">Pago único</span>
                    </td>
                    <td :class="{ 'd-none': !columnasVisibles.enlace }">{{ row.enlace }}</td>
                    <td :class="{ 'd-none': !columnasVisibles.precio }">{{ fmtPrecio(row.precio, row.moneda) }}</td>
                    <td :class="{ 'd-none': !columnasVisibles.precio_real }">
                      <span v-if="row.precio_real !== null" class="precio-real-badge">
                        {{ fmtPrecio(row.precio_real, row.moneda) }}
                      </span>
                      <span v-else class="texto-muted">—</span>
                    </td>
                    <td :class="{ 'd-none': !columnasVisibles.tipster }" v-if="miRol==1">{{ row.tipster }}</td>
                    <td>{{ row.activo }}</td>
                    <td :class="{ 'd-none': !columnasVisibles.creado }">{{ row.created }}</td>
                    <td :class="{ 'd-none': !columnasVisibles.eliminado }" v-if="mostrarBorrados">{{ row.deleted }}</td>
                    <td>
                      <template v-if="!row.deleted">
                        <a href="#" class="cursor-pointer me-3" data-bs-toggle="tooltip" title="Editar Producto"
                           @click.prevent="editarProducto(row)">
                          <i class="fas fa-edit text-secondary"></i>
                        </a>
                        <a href="#" class="cursor-pointer me-3" data-bs-toggle="tooltip" title="Eliminar Producto"
                           @click.prevent="mostrarConfirmacionBorrar(row.id)">
                          <i class="fas fa-trash text-secondary"></i>
                        </a>
                        <a href="#" class="cursor-pointer me-3"
                           :title="'Copiar enlace bonito: ' + (row.urlcompra_bonita || row.urlcompra)"
                           @click.prevent="copiarEnlace(row.urlcompra_bonita || row.urlcompra)"
                           @contextmenu.prevent="abrirEnlace(row.urlcompra_bonita || row.urlcompra)">
                          <i class="fas fa-link text-secondary"></i>
                        </a>
                        <a v-if="miRol == 1" href="#" class="cursor-pointer me-3"
                           title="Copiar enlace completo (UUID)"
                           @click.prevent="copiarEnlace(row.urlcompra)"
                           @contextmenu.prevent="abrirEnlace(row.urlcompra)">
                          <i class="fas fa-clipboard text-secondary"></i>
                        </a>
                      </template>
                    </td>
                  </tr>
                  <tr v-if="filasVisibles.length==0"><td colspan="7">No hay registros que mostrar</td></tr>
                </tbody>
              </table>
            </div>
            <!-- Control de la Paginacion manual -->
            <div class="paginacion" v-if="filas.length>0">
              <p class="contador-listado">Mostrando {{ mostradosIni }} a {{ mostradosFin }} de {{ mostradosTotal }} registros</p>

              <ul class="pagination pagination-md" v-if="paginaTotal>1">
                <li class="page-item prev-page" v-if="paginaActual>1">
                  <a class="page-link" aria-label="Previous" @click="paginaActual=paginaActual-1;fetchAndSetProductos();">
                    <i class="fa fa-angle-left" aria-hidden="true"></i>
                  </a>
                </li>
                <li v-for="index in rangoPaginas" :key="index" class="page-item" :class="index==paginaActual ? 'active disabled' : ''">
                  <a class="page-link" @click="paginaActual=index;fetchAndSetProductos();">{{index}}</a>
                </li>
                <li class="page-item next-page" v-if="paginaActual<paginaTotal">
                  <a class="page-link" aria-label="Next" @click="paginaActual=paginaActual+1;fetchAndSetProductos();">
                    <i class="fa fa-angle-right" aria-hidden="true"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <Modal @cerrar-modal="cerrarModal" :modalActive="modalActive">
    <div class="modal-content">
      <producto-form
        v-if="tipoModal=='A'"
        modo="alta"
        :bot-name="botName"
        @cerrar-modal="() => { this.modalActive=false;fetchAndSetProductos();}"
        :key="modalKey"
      ></producto-form>
      <producto-form
        v-if="tipoModal=='E'"
        modo="edita"
        @cerrar-modal="() => { this.modalActive=false;fetchAndSetProductos();}"
        :key="productoEditId"
        :productoId="productoEditId"
        :productoNombre="productoEditName"
        :productoEnlace="productoEditEnlace"
        :productoPrecio="productoEditPrecio"
        :productoActivo="productoEditActivo"
        :productoTipsterId="productoEditTipsterId"
        :productoDescripcion="productoEditDescripcion"
        :productoTipoVenta="productoEditTipoVenta"
        :productoPublicoObjetivo="productoEditPublicoObjetivo"
        :productoUsaFecha="productoEditUsaFecha"
        :productoFechaLimite="productoEditFechaLimite"
        :productoHoraLimite="productoEditHoraLimite"
        :productoDescuentos="productoEditDescuentos"
        :productoCanalUuid="productoEditCanalUuid"
        :productoTieneSuscriptores="productoEditTieneSuscriptores"
        :productoDiasGracia="productoEditDiasGracia"
        :productoMoneda="productoEditMoneda"
      ></producto-form>


    </div>
  </Modal>

  <div v-if="confirmacionVisible" class="overlay">
    <div class="confirm-box">
      <p class="mt-4 mb-4">{{ mensajeConfirmacion }}</p>
      <table class="mt-4 mb-4"><tr>
        <td width="50%"><QBtn variant="cancela" label="Cancelar" @click="cancelacion" /></td>
        <td width="50%"><QBtn variant="confirma" label="Confirmar" @click="confirmacion" /></td>
      </tr></table>
    </div>
  </div>
</template>

<script>
import showSwal from "@/mixins/showSwal.js";
import Modal from './components/ModalServicio.vue';
import ProductoForm from './components/ProductoForm.vue';
import {globalFunctionsMixin} from '@/mixins/globalFunctions.js';

const STORAGE_KEY_COLUMNAS = 'productos_columnas_v1';

const COLUMNAS_DEFAULT = {
  enlace: false, precio: true, precio_real: true, tipster: true, creado: true, eliminado: true,
};

const COLUMNAS_MOBILE = {
  enlace: false, precio: false, precio_real: false, tipster: false, creado: false, eliminado: false,
};

export default {
  name: "Productos",
  components: {
    Modal,
    ProductoForm,
  },
  directives: {
    clickOutside: {
      beforeMount(el, binding) {
        el._clickOutsideHandler = (e) => { if (!el.contains(e.target)) binding.value(e); };
        setTimeout(() => document.addEventListener('click', el._clickOutsideHandler), 0);
      },
      unmounted(el) { document.removeEventListener('click', el._clickOutsideHandler); },
    },
  },
  mixins: [globalFunctionsMixin],
  data() {
    return {
      modalKey: 0,
      filas: [],
      productos: [],
      confirmacionVisible: false,
      productoId: 0,
      mensajeConfirmacion: '',
      tipoModal: '',
      productoEditId: 0,
      productoEditActivo: '',
      productoEditEnlace: '',
      productoEditName: '',
      productoEditPrecio: '',
      productoEditTipster: '',
      productoEditTipsterId: '',
      listaTipsters: [],
      filtroTipsterId: '',
      textoBuscador: '',
      paginaActual: 0,
      paginaTotal: 0,
      mostrarBorrados: false,
      mostradosIni: 0,
      mostradosFin: 0,
      mostradosTotal: 0,
      sortColumn: 0,
      sortDirection: '',
      modalActive: false,
      searchTimeout: null,
      productoEditDescripcion: '',
      productoEditTipoVenta: '',
      productoEditPublicoObjetivo: '',
      productoEditUsaFecha: false,
      productoEditFechaLimite: '',
      productoEditHoraLimite: '',
      productoEditDescuentos: [],
      productoEditCanalUuid: "",
      productoEditTieneSuscriptores: false,
      productoEditDiasGracia: 0,
      productoEditMoneda: "EUR",
      botName: "",
      filtroTipo: '',
      filtroActivo: '',
      selectorColumnasAbierto: false,
      columnasVisibles: { ...COLUMNAS_DEFAULT },
    };
  },
  computed: {
    miRol() { return this.$store.getters["auth/rolEfectivo"]; },
    columnasConfig() {
      const cols = [
        { key: 'enlace',  label: 'Enlace',  color: '#6b7280' },
        { key: 'precio',      label: 'Precio',      color: '#00e676' },
        { key: 'precio_real', label: 'Precio real', color: '#ffc107' },
        { key: 'creado',      label: 'Creado',      color: '#6b7280' },
      ];
      if (Number(this.miRol) === 1) {
        cols.splice(2, 0, { key: 'tipster', label: 'Tipster', color: '#6b7280' });
      }
      if (this.mostrarBorrados) {
        cols.push({ key: 'eliminado', label: 'Eliminado', color: '#ef4444' });
      }
      return cols;
    },
    filasVisibles() {
      let rows = this.filas;
      if (this.filtroTipo === 'suscripcion') rows = rows.filter(r => r.tipo_venta !== 'venta_unica');
      else if (this.filtroTipo === 'unico') rows = rows.filter(r => r.tipo_venta === 'venta_unica');
      if (this.filtroActivo === 'activo') rows = rows.filter(r => String(r.activo).toLowerCase() === 'si');
      else if (this.filtroActivo === 'inactivo') rows = rows.filter(r => String(r.activo).toLowerCase() !== 'si');
      return rows;
    },
    rangoPaginas() {
      let startPage = Math.max(this.paginaActual - 3, 1);
      let endPage = Math.min(this.paginaActual + 3,this.paginaTotal);
      let pages = [];
      for (let i = startPage; i <= endPage; i++) {
        pages.push(i);
      }
      return pages;
    }
  },
  methods: {
    toggleSelectorColumnas() {
      this.selectorColumnasAbierto = !this.selectorColumnasAbierto;
    },
    cerrarSelectorColumnas() {
      this.selectorColumnasAbierto = false;
    },
    guardarColumnasStorage() {
      try { localStorage.setItem(STORAGE_KEY_COLUMNAS, JSON.stringify(this.columnasVisibles)); } catch (e) { /* storage no disponible */ }
    },
    resetColumnas() {
      const esMobile = window.innerWidth < 768;
      this.columnasVisibles = { ...(esMobile ? COLUMNAS_MOBILE : COLUMNAS_DEFAULT) };
      this.guardarColumnasStorage();
    },
    cargarColumnasStorage() {
      try {
        const guardado = localStorage.getItem(STORAGE_KEY_COLUMNAS);
        if (guardado) {
          this.columnasVisibles = { ...COLUMNAS_DEFAULT, ...JSON.parse(guardado) };
        } else {
          this.columnasVisibles = { ...(window.innerWidth < 768 ? COLUMNAS_MOBILE : COLUMNAS_DEFAULT) };
        }
      } catch {
        this.columnasVisibles = { ...COLUMNAS_DEFAULT };
      }
    },

    async descargarCSV() {
      try {
        const response = await this.$store.dispatch("auth/exportarProductos");
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "productos_" + new Date().toISOString().slice(0, 10) + ".xlsx");
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      } catch (e) {
        showSwal.methods.showSwal({ type: "error", message: "No se pudo generar el archivo.", width: 400 });
      }
    },

    async cargarBotName() {
    try {
      const resp = await this.$store.dispatch("auth/configuracion", {
        tipo: "bot",
        silent403: true,
      });

      const lista = resp.data || [];

      // 👇 Aquí el cambio importante: usamos `nombre === 'bot'`
      const paramBot = lista.find(p => p.nombre === "bot");

      this.botName = paramBot ? paramBot.valor : "";
    } catch (e) {
      console.error("No se pudo cargar el nombre del bot", e);
      this.botName = "";
    }
  },


    alert() {
      showSwal.methods.showSwal({
        type: "error",
        message: "This is a PRO feature.",
        width: 400,
      });
    },

    async initializeDataTable() {
      this.sortColumn=5;
      this.sortDirection='desc';
      this.textoBuscador = '';
      this.paginaActual = 1;
      await this.fetchAndSetProductos();
    },

    sortTable(key) {
      // Alternar entre ascendente y descendente al hacer clic en el encabezado
      if (this.sortColumn === key) {
        this.sortDirection = this.sortDirection=='asc' ? 'desc' : 'asc';
      } else {
        this.sortColumn = key;
        this.sortDirection = 'asc';
      }
      this.fetchAndSetProductos();
    },

    cambiarFiltroTipster() {
      this.paginaActual = 1;
      this.fetchAndSetProductos();
    },

    teclearBuscador(event) {
      this.textoBuscador = event.target.value;
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.fetchAndSetProductos();
      }, 500);
    },

    async fetchAndSetProductos() {
      try {
        // Petición al servidor
        const response = await this.$store.dispatch("auth/productos", { textoBuscador: this.textoBuscador, paginaActual: this.paginaActual, mostrarBorrados: this.mostrarBorrados, sortColumn: this.sortColumn, sortDirection: this.sortDirection, tipster_id: this.filtroTipsterId || null });
        this.productos = response;
        // Procesar los datos y actualizarlos en el DataTable
        this.filas = response.data.map(row => ({
          id: row.id,
          nombre: row.nombre,
          enlace: row.enlace,
          precio: row.precio,
          precio_real: row.precio_real ?? null,
          activo: row.activo,
          tipster: row.tipster,
          tipster_id: row.tipster_id,

          created: this.formatDate(row.created_at, 'DD/MM/YYYY'),
          deleted: row.deleted_at ? this.formatDate(row.deleted_at, 'DD/MM/YYYY') : '',
          descripcion: row.descripcion,
          tipo_venta: row.tipo_venta,
          publico_objetivo: row.publico_objetivo ?? "",
          usa_fecha_limite: row.usa_fecha_limite,
          fecha_limite: row.fecha_limite,
          hora_limite: row.hora_limite,
          descuentos: row.descuentos,
          canal_uuid: row.canal_uuid ?? "",
          dias_gracia: row.dias_gracia ?? 0,
          tiene_suscriptores: row.tiene_suscriptores ?? false,
          moneda: row.moneda || 'EUR',
          urlcompra: row.urlcompra,
          urlcompra_bonita: row.urlcompra_bonita ?? null,
        }));


        this.paginaTotal = response.paginas;
        this.mostradosIni = (response.actual-1)*response.porpagina + 1;
        this.mostradosFin = Math.min(response.totales,response.actual*response.porpagina);
        this.mostradosTotal = response.totales;
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    },

    mostrarConfirmacionBorrar(id) { 
      this.confirmacionVisible = true;
      this.productoId = id;
      this.mensajeConfirmacion = '¿Confirma que desea eliminar este producto?';
    },
    confirmacion() {
      this.confirmacionVisible = false;
      this.borrarProducto(this.productoId);
    },
    cancelacion() {
      this.confirmacionVisible = false;
    },
    async abrirAltaProducto() {
      this.tipoModal = 'A';
      this.modalKey++; 
      this.modalActive = true; 
        // 🔥 Enviar señal al componente hijo cuando se abre
    },
    cerrarModal() {
      this.modalActive = false;
    },
    async cambiarBorrados() {
      await this.initializeDataTable();
    },
    async borrarProducto(productoId) {
      try {
        const resp = await this.$store.dispatch("auth/borraProducto",{id: productoId});
        if (resp.res=='OK') {
            showSwal.methods.showSwal({
                type: "success",
                message: resp.mensaje,
                width: 600,
            });
            this.fetchAndSetProductos();
            this.$emit('cerrar-modal');
        }
        else {
            showSwal.methods.showSwal({
                type: "error",
                message: resp.mensaje,
                width: 500
            });               
        }
      } 
      catch (error) {
        showSwal.methods.showSwal({
            type: "error",
            message: "Se ha producido un error",
            width: 500,
        });
      }
    },
    editarProducto(row) {
      this.$nextTick(() => {
        this.modalActive = true;
        this.tipoModal = 'E';
        this.productoEditActivo = row.activo.toString().toLowerCase() === "si";
        this.productoEditEnlace = row.enlace;
        this.productoEditName = row.nombre;
        this.productoEditPrecio = row.precio;
        this.productoEditTipster = row.tipster_id?.toString() ?? '';
        this.productoEditTipsterId = row.tipster_id?.toString() ?? '';
        this.productoEditDescripcion = row.descripcion ?? "";
        this.productoEditTipoVenta = row.tipo_venta ?? "";
        this.productoEditPublicoObjetivo = row.publico_objetivo ?? "";
        this.productoEditUsaFecha = row.usa_fecha_limite == 1;
        this.productoEditFechaLimite = row.fecha_limite ?? "";
        this.productoEditHoraLimite = row.hora_limite ?? "";
        this.productoEditDescuentos = row.descuentos ?? [];
        this.productoEditCanalUuid = row.canal_uuid ?? "";
        this.productoEditTieneSuscriptores = row.tiene_suscriptores ?? false;
        this.productoEditDiasGracia = Number(row.dias_gracia) || 0;
        this.productoEditMoneda = row.moneda || "EUR";
        this.productoEditId = row.id;
        setTimeout(() => {
          const editor = document.querySelector("trix-editor[input='descripcion']");
          if (editor && this.productoEditDescripcion) {
            editor.editor.loadHTML(this.productoEditDescripcion);
          }
        }, 150);
      });
    },

    copiarEnlace(url) {
      navigator.clipboard.writeText(url).then(() => {
        showSwal.methods.showSwal({
          type: "success",
          message: 'Enlace copiado al portapapeles',
          width: 600,
        });
      });
    },

    abrirEnlace(url) {
      window.open(url, '_blank');
    },

    fmtPrecio(n, moneda) {
      if (n === null || n === undefined || n === '') return '—';
      const cur = (moneda || 'EUR').toUpperCase();
      const locale = cur === 'USD' ? 'en-US' : 'es-ES';
      return Number(n).toLocaleString(locale, { style: 'currency', currency: cur });
    },

    irInicio() {
      this.$router.push('/dashboard');
    }
  },

  async mounted() {
    this.$store.commit('setShowFooter', true);
    this.cargarColumnasStorage();
    if (this.miRol == 1) {
      const resp = await this.$store.dispatch("auth/listaTipsters");
      this.listaTipsters = Array.isArray(resp) ? resp : [];
    }
    await this.cargarBotName();
    this.initializeDataTable();
  },

};
</script>

<style scoped>
.descarga.triple {
  grid-template-columns: repeat(3, 1fr);
}

.descarga p.activo i { color: var(--q-gold, #ffd700); }

.selector-columnas-panel {
  position: absolute;
  top: calc(100% + 8px);
  right: 1rem;
  z-index: 999;
  background: var(--q-card, #1a1f2b);
  border: 1px solid var(--q-border, rgba(255,255,255,.1));
  border-radius: 12px;
  padding: 0;
  min-width: 280px;
  box-shadow: 0 12px 40px rgba(0,0,0,.4);
  overflow: hidden;
}
.selector-columnas-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.65rem 1rem;
  font-size: 0.8rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .06em;
  color: var(--q-muted, #888);
  border-bottom: 1px solid var(--q-border, rgba(255,255,255,.08));
  background: var(--q-hover, rgba(255,255,255,.04));
}
.selector-reset {
  font-size: 0.72rem;
  color: var(--q-gold, #ffd700);
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  opacity: .75;
  transition: opacity .15s;
}
.selector-reset:hover { opacity: 1; }
.selector-columnas-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2px;
  padding: 0.5rem;
}
.selector-col-item {
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 6px 10px;
  border-radius: 8px;
  font-size: 0.8rem;
  cursor: pointer;
  transition: background .12s;
  user-select: none;
}
.selector-col-item:hover { background: var(--q-hover, rgba(255,255,255,.06)); }
.selector-col-item input[type="checkbox"] { margin: 0; cursor: pointer; accent-color: var(--q-gold, #ffd700); }
.selector-col-dot {
  width: 8px; height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

/* ficha-buscador necesita position:relative para que el panel se posicione bien */
.ficha-buscador { position: relative; }

.borrados {
  display: flex;
  align-items: center;
  gap: 8px;
}
.borrados-label {
  font-size: 0.78rem;
  color: var(--q-muted);
  white-space: nowrap;
}
.filtro-tipster {
  display: flex;
  align-items: center;
  padding: 0 1rem;
}
.filtro-tipster select {
  min-width: 180px;
  font-size: 0.82rem;
}
.filtros-prod {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem 1.5rem;
  padding: 0 1rem 0.5rem;
  align-items: center;
}
.filtros-prod__grupo {
  display: flex;
  gap: 0.4rem;
  flex-wrap: wrap;
}
.filtro-pill {
  font-size: 0.75rem;
  padding: 3px 12px;
  border-radius: 20px;
  border: 1px solid var(--q-border, #dee2e6);
  background: transparent;
  color: var(--q-muted, #6c757d);
  cursor: pointer;
  transition: background 0.15s, color 0.15s, border-color 0.15s;
  line-height: 1.6;
}
.filtro-pill:hover {
  background: var(--q-hover, rgba(0,0,0,0.05));
}
.filtro-pill--active {
  background: #203353;
  color: #fff;
  border-color: #203353;
}
.prod-badge {
  display: inline-block;
  font-size: 0.65rem;
  font-weight: 600;
  padding: 1px 7px;
  border-radius: 10px;
  margin-left: 6px;
  vertical-align: middle;
  letter-spacing: 0.02em;
  white-space: nowrap;
}
.prod-badge--susc {
  background: #e8f0fe;
  color: #2563eb;
}
.prod-badge--unico {
  background: #e6f9f0;
  color: #15803d;
}

.precio-real-badge {
  display: inline-block;
  background: rgba(255, 193, 7, 0.15);
  color: #ffc107;
  font-weight: 600;
  font-size: 0.8rem;
  padding: 2px 8px;
  border-radius: 10px;
  white-space: nowrap;
}
.texto-muted {
  color: var(--q-muted, #6c757d);
  font-size: 0.85rem;
}
</style>



